// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"fd05b0f7","165":"49484500","319":"e1925a72","453":"d3ea2a8d","492":"6582f466","808":"c3eaee2a","932":"cb1fb7cf","959":"de15176e"}[chunkId] + ".chunk.js";
};